// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PDL_headerRow__ciK0C {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.PDL_titleWrap__AmCCF {
  display: flex;
  align-items: center;
  gap: 8px;
}

.PDL_titleBar__WnhPB { 
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #2f7ed8;
  flex-shrink: 0;
}

.PDL_title__IJFjX {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.95rem;
}

.PDL_subtitle__MJcgs {
  color: #9ca3af;
  font-size: 0.78rem;
  margin-left: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/PDL/PDL.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.titleWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.titleBar { \n  width: 4px;\n  height: 18px;\n  border-radius: 2px;\n  background: #2f7ed8;\n  flex-shrink: 0;\n}\n\n.title {\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 0.95rem;\n}\n\n.subtitle {\n  color: #9ca3af;\n  font-size: 0.78rem;\n  margin-left: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `PDL_headerRow__ciK0C`,
	"titleWrap": `PDL_titleWrap__AmCCF`,
	"titleBar": `PDL_titleBar__WnhPB`,
	"title": `PDL_title__IJFjX`,
	"subtitle": `PDL_subtitle__MJcgs`
};
export default ___CSS_LOADER_EXPORT___;
